import { render } from "./detail.vue?vue&type=template&id=4b55472e&scoped=true&ts=true"
import script from "./detail.vue?vue&type=script&lang=tsx"
export * from "./detail.vue?vue&type=script&lang=tsx"

import "./detail.vue?vue&type=style&index=0&id=4b55472e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b55472e"]])

export default __exports__